// extracted by mini-css-extract-plugin
export default {"wrapper":"zp-z","response":"Ap-z","error":"Bp-z","disabled":"Cp-z","buttons":"Dp-z","feedbackQuestionSection":"Ep-z","yesNoWrapper":"Fp-z"};